import BaseApi from '../base/base'
import Menu from '../../models/menu'

export default class MenuApi extends BaseApi {
  constructor() {
    super()
    this.path = '/menus'
  }

  async index() {
    this.path = '/menus'
    const response = await this.getRequest()
    return (response.data || []).map((item) => new Menu(item))
  }
}
